/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
GOOGLE_processor_version: 294144208
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/FlowerDesertLily/DesertLily.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[0.28, 2.59, -0.09]}>
        <group position={[-0.28, -2.59, 0.09]}>
          <mesh material={materials.DeserLily_Mat} geometry={nodes['node-0'].geometry} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/FlowerDesertLily/DesertLily.gltf')
